module.exports = __webpack_public_path__ + "assets/img/2151591934007_.pic_hd.c11f60c1.jpg";